import { render, staticRenderFns } from "./RecruiterFees.vue?vue&type=template&id=427fd1d2&"
import script from "./RecruiterFees.vue?vue&type=script&lang=js&"
export * from "./RecruiterFees.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports